<template>
    <v-container class="py-0">
        <div class="detail-topbar">
            <back-button />
        </div>
        <v-row v-if="!hideStudentInfo">
            <v-col cols="12" md="6" offset-md="3" xl="4" offset-xl="4">
                <student-info-card class="mb-3" v-if="currentRoutine" :studentId="currentRoutine.studentId" />
                <skeleton-loader v-else type="athlete" class="mb-3" />
            </v-col>
        </v-row>
        <assigned-routine-detail :hide-student-info="hideStudentInfo" readonly :assignedRoutineId="assignedRoutineId"
            @showSummary="showSummary" no-container />
        <summary-assigned-routine-dialog back-button ref="summary" :assignedRoutineId="assignedRoutineId"
            is-coach-watch />
    </v-container>
</template>

<script>

import AssignedRoutineDetail from '@/components/common/routines/AssignedRoutineDetail'
import StudentInfoCard from '@/components/coach/routines/StudentInfoCard'
import { mapMutations, mapState } from 'vuex'
import SummaryAssignedRoutineDialog from "@/components/student/SummaryAssignedRoutineDialog";
import BackButton from "@/components/common/BackButton";
import SkeletonLoader from "@/components/common/SkeletonLoader";

export default {
    components: {
        BackButton,
        SummaryAssignedRoutineDialog,
        AssignedRoutineDetail,
        StudentInfoCard,
        SkeletonLoader
    },
    data() {
        return {
            hideStudentInfo: false,
        }
    },
    computed: {
        ...mapState(['currentRoutine']),
        assignedRoutineId(vm = this) {
            return vm.$route.params.uid
        },
    },
    methods: {
        ...mapMutations(['setCurrentRoutine', 'setTitle']),
        showSummary() {
            const vm = this
            vm.$refs.summary.show()
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name === `${vm.accountType}.routines.program.detail`) vm.hideStudentInfo = true
        })
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        const studentId = vm.currentRoutine?.studentId || null
        const date = vm.currentRoutine?.rawDate?.full || null
        vm.setCurrentRoutine(null)
        vm.setTitle('')
        if (to.name === `${vm.accountType}.calendar` && studentId) {
            next({
                name: to.name,
                params: to.params,
                query: { ...to.query, studentId, ...(date ? { date } : {}) },
                replace: true
            })

            return;
        }
        next()
    }
}
</script>

<style scoped>
.detail-topbar {
    display: flex;
    align-items: center;
    padding: 4px 0 12px;
}
</style>